const ReviewList = ({ reviews }) => {
  if (!reviews || reviews.length === 0) {
    return <p className="text-gray-400 mt-4">No reviews yet. Be the first to review!</p>;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-8">
      {reviews.map((review, index) => (
        <div
          key={index}
          className="bg-gradient-to-br from-gray-800 to-gray-900 border border-purple-700 rounded-2xl p-4 shadow-lg hover:shadow-pink-500/30 transition-all duration-300"
        >
          <div className="flex items-center mb-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <svg
                key={star}
                xmlns="http://www.w3.org/2000/svg"
                fill={review.rating >= star ? "#FACC15" : "none"}
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="w-5 h-5 text-yellow-400"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 17.27l5.18 3.73-1.64-6.36 5-4.73-6.46-.53L12 2 9.92 9.38l-6.46.53 5 4.73-1.64 6.36L12 17.27z" />
              </svg>
            ))}
          </div>
          <p className="text-sm text-gray-300 min-h-[60px]">"{review.review}"</p>
          <p className="text-xs text-purple-400 font-semibold">{review.name}</p>
        </div>
      ))}
    </div>
  );
};

export default ReviewList;

